import React from "react";
import { API } from '@aws-amplify/api';
import {  useNavigation } from "react-router-dom";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from '@mui/x-data-grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


export const xxxusersLoader = async () => {
  console.log("starting Users usersLoader");
  const apiName = 'apic48d2c9b';
  const path = "/users" //+ ucs.customer.name.customer_id;
  const myInit = {
    headers: {'Content-Type':'application/json'}, 
      response: true
  };
  var response = await API.get(apiName, path, myInit);
  var data_returned =  await response.data;
  console.log('data_returned from userlist', data_returned);
  return data_returned;
}

export const userDelete = async (u_id) => {
  console.log("starting userDelete");
  const apiName = 'apic48d2c9b';
  const path = "users/"  + u_id; //+ ucs.customer.name.customer_id;
  const myInit = {
    headers: {'Content-Type':'application/json'},
    body: u_id,
    response: true
  };
  var response = await API.del(apiName, path, myInit);
  return await response.data;
}


export function Users(props_in) {
  // var xsettings = useLoaderData();
  //console.log('xsets',xsettings);
  const navigation = useNavigation();  
  console.log('userList propped in...', props_in)
  const settings_object = JSON.parse(props_in.setting_info);
  const user_list = settings_object.users;
  console.log('userlist info derived',user_list);
  function handleDelete(u_id) {
    console.log('would delete id',u_id)
    userDelete(u_id);
  }

  function handleAdminChange(e)
 {
  console.log('admin status change. event->', e);

 }

 function saveRow(formData) {
  const query = formData.get('query');
  alert (`YOu sarch fored ${query}`);
 }

   
 if (navigation.state === "loading") {
  return <div><h1>Loading Settings...</h1></div>
}
  console.log('from the dataloader inside users', user_list);


  return (

    <TableContainer component={Paper}>
    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>           
            <TableCell align="left">email</TableCell>
            <TableCell align="left">Last Login</TableCell>
            <TableCell align="left">is admin</TableCell>       
            <TableCell align="left">Actions</TableCell>        
          </TableRow>
        </TableHead>
        <TableBody>
            {user_list && user_list.map((one_user) => (

            <TableRow
              key={one_user.user_email.S}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              
              <TableCell component="th" scope="row">
              {one_user.user_email.S}
              </TableCell>
            
              <TableCell align="left">{one_user.last_login.N}</TableCell>
              <TableCell align="left">
                <input type="checkbox" checked={one_user.user_isadmin.BOOL ? "checked" : "unchecked"} onChange={handleAdminChange}/>
                </TableCell>


                <TableCell align="left"> <button onClick={() => handleDelete(one_user.user_id.S)}>DEL</button></TableCell>
                
            </TableRow>
               
            ))}
            </TableBody>
           </Table>
       </TableContainer>    
 
 
  ) ;
}
